// CLIENTS
import {
  GET_CLIENTS,
  GET_CLIENTS_SUCCESS,
  GET_CLIENT,
  GET_CLIENT_SUCCESS,
  CREATE_CLIENT,
  CREATE_CLIENT_SUCCESS,
  DELETE_CLIENT,
  DELETE_CLIENT_SUCCESS,
  SELECT_CLIENT,
  ADD_CLIENT,
  UPDATE_CLIENT,
  UPDATE_CLIENT_SUCCESS,
  EDIT_CLIENT,
  CANCEL_CREATE,
  CANCEL_UPDATE,
  CLIENTS_ERROR,
  SET_CLIENT,
  GET_CLIENT_WHITELABEL,
  CREATE_CLIENT_WHITELABEL,
  DELETE_CLIENT_WHITELABEL,
  SET_SUBSCRIPTION,
  ADD_SUBSCRIPTION_CLIENT,
  REMOVE_SUBSCRIPTION_CLIENT,
  UPDATE_CLIENT_APPS,
  ADD_LOADING_CLIENT,
  REMOVE_LOADING_CLIENT,
  CLEAR_LOADING_CLIENT,
  UPDATE_USER_LIST,
  UPDATE_CLIENT_LIST,
  UPDATE_APPROLE_LIST,
  SET_CAPUROLE,
  ADD_SUBSCRIPTION_CLIENT_SUCCESS,
  REMOVE_SUBSCRIPTION_CLIENT_SUCCESS,
  GET_CLIENT_AUDIT_LOGS,
  GET_CLIENT_AUDIT_LOGS_SUCCESS,
} from '../constants/action-types/clients';

export const getClients = () => ({
  type: GET_CLIENTS,
});

export const getClientsSuccess = data => ({
  type: GET_CLIENTS_SUCCESS,
  data,
});

export const getClient = id => ({
  type: GET_CLIENT,
  id,
});

export const getClientSuccess = data => ({
  type: GET_CLIENT_SUCCESS,
  data,
});

export const selectClient = id => ({
  type: SELECT_CLIENT,
  id,
});

export const addClient = () => ({
  type: ADD_CLIENT,
});

export const createClient = data => ({
  type: CREATE_CLIENT,
  data,
});

export const createClientSuccess = data => ({
  type: CREATE_CLIENT_SUCCESS,
  data,
});

export const updateClient = (id, data) => ({
  type: UPDATE_CLIENT,
  id,
  data,
});

export const updateClientSuccess = data => ({
  type: UPDATE_CLIENT_SUCCESS,
  data,
});

export const deleteClient = id => ({
  type: DELETE_CLIENT,
  id,
});

export const deleteClientSuccess = () => ({
  type: DELETE_CLIENT_SUCCESS,
});

export const editClient = () => ({
  type: EDIT_CLIENT,
});

export const cancelCreate = () => ({
  type: CANCEL_CREATE,
});

export const cancelUpdate = id => ({
  type: CANCEL_UPDATE,
  id,
});

export const clientsError = () => ({
  type: CLIENTS_ERROR,
});

export const addSubscriptionClientSuccess = () => ({
  type: ADD_SUBSCRIPTION_CLIENT_SUCCESS,
});

export const removeSubscriptionClientSuccess = () => ({
  type: REMOVE_SUBSCRIPTION_CLIENT_SUCCESS,
});

export const setClient = cid => ({
  type: SET_CLIENT,
  cid,
});

export const getClientWhitelabel = id => ({
  type: GET_CLIENT_WHITELABEL,
  id,
});

export const createClientWhitelabel = (id, data) => ({
  type: CREATE_CLIENT_WHITELABEL,
  id,
  data,
});

export const deleteClientWhitelabel = (id, clientId) => ({
  type: DELETE_CLIENT_WHITELABEL,
  id,
  clientId,
});

export const getClientAuditLogs = id => ({
  type: GET_CLIENT_AUDIT_LOGS,
  id,
});

export const getClientAuditLogsSuccess = data => ({
  type: GET_CLIENT_AUDIT_LOGS_SUCCESS,
  data,
});

export const SetSubscriptionClient = sub => ({
  type: SET_SUBSCRIPTION,
  sub,
});

export const addClientSubscription = tier => ({
  type: ADD_SUBSCRIPTION_CLIENT,
  tier,
});

export const removeClientSubscription = () => ({
  type: REMOVE_SUBSCRIPTION_CLIENT,
});

export const updateClientApps = apps => ({
  type: UPDATE_CLIENT_APPS,
  apps,
});

export const removeLoadingClient = action => ({
  type: REMOVE_LOADING_CLIENT,
  action,
});

export const addLoadingClient = action => ({
  type: ADD_LOADING_CLIENT,
  action,
});

export const clearLoadingClient = () => ({
  type: CLEAR_LOADING_CLIENT,
});

export const updateUsers = users => ({
  type: UPDATE_USER_LIST,
  users,
});

export const changeClientAppUserRole = roleParams => ({
  type: SET_CAPUROLE,
  roleParams,
});

export const updateAppRoleList = approles => ({
  type: UPDATE_APPROLE_LIST,
  approles,
});

export const updateClients = clients => ({
  type: UPDATE_CLIENT_LIST,
  clients,
});
